import { render, staticRenderFns } from "./checkboxWeekday.vue?vue&type=template&id=2a094dfe&scoped=true&"
import script from "./checkboxWeekday.vue?vue&type=script&lang=js&"
export * from "./checkboxWeekday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a094dfe",
  null
  
)

export default component.exports